module.exports = __webpack_public_path__ + "static/media/400380_01.e5e4213f.png";